import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { adminLogin } from '../services/api';
import { useAdminAuth } from '../context/AdminAuthContext';

export default function Login() {
  const [email, setEmail]       = useState('');
  const [password, setPassword] = useState('');
  const [showPass, setShowPass] = useState(false);
  const [loading, setLoading]   = useState(false);
  const [error, setError]       = useState('');
  const { loginAdmin }          = useAdminAuth();
  const navigate                = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(''); setLoading(true);
    try {
      const data = await adminLogin({ email, password });
      if (data.user?.role !== 'admin') return setError('Access denied. Admin only.');
      loginAdmin(data.token, data.user);
      navigate('/dashboard');
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', background: 'linear-gradient(135deg, #0A1628 0%, #1a2d4f 100%)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ background: '#fff', borderRadius: 20, padding: '40px 36px', width: '100%', maxWidth: 420, boxShadow: '0 24px 64px rgba(0,0,0,0.3)' }}>
        {/* Logo */}
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <div style={{ width: 56, height: 56, borderRadius: 16, background: '#0066FF', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 24, color: '#fff', margin: '0 auto 14px' }}>
            <i className="fa fa-briefcase"></i>
          </div>
          <h2 style={{ fontWeight: 800, color: '#0A1628', margin: '0 0 4px' }}>Admin Panel</h2>
          <p style={{ color: '#888', fontSize: 14, margin: 0 }}>JustHiring24 — Restricted Access</p>
        </div>

        {error && (
          <div style={{ background: '#fff0f0', color: '#ef4444', padding: '12px 16px', borderRadius: 10, fontSize: 13, marginBottom: 20, display: 'flex', alignItems: 'center', gap: 8 }}>
            <i className="fa fa-exclamation-circle"></i> {error}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: 16 }}>
            <label style={{ fontSize: 13, fontWeight: 600, color: '#444', display: 'block', marginBottom: 6 }}>Email Address</label>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, background: '#fafbff', border: '1.5px solid #eef0f8', borderRadius: 10, padding: '11px 14px' }}>
              <i className="fa fa-envelope" style={{ color: '#aaa' }}></i>
              <input type="email" placeholder="admin@justhiring24.com" value={email} onChange={e => setEmail(e.target.value)} required
                style={{ border: 'none', outline: 'none', background: 'transparent', fontSize: 14, width: '100%' }} />
            </div>
          </div>

          <div style={{ marginBottom: 24 }}>
            <label style={{ fontSize: 13, fontWeight: 600, color: '#444', display: 'block', marginBottom: 6 }}>Password</label>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, background: '#fafbff', border: '1.5px solid #eef0f8', borderRadius: 10, padding: '11px 14px' }}>
              <i className="fa fa-lock" style={{ color: '#aaa' }}></i>
              <input type={showPass ? 'text' : 'password'} placeholder="Enter admin password" value={password} onChange={e => setPassword(e.target.value)} required
                style={{ border: 'none', outline: 'none', background: 'transparent', fontSize: 14, flex: 1 }} />
              <button type="button" onClick={() => setShowPass(!showPass)} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#aaa' }}>
                <i className={`fa ${showPass ? 'fa-eye-slash' : 'fa-eye'}`}></i>
              </button>
            </div>
          </div>

          <button type="submit" disabled={loading} style={{ width: '100%', padding: '13px', borderRadius: 12, border: 'none', background: '#0066FF', color: '#fff', fontWeight: 700, fontSize: 15, cursor: 'pointer', boxShadow: '0 4px 14px rgba(0,102,255,0.35)' }}>
            {loading ? <><i className="fa fa-spinner fa-spin me-2"></i> Signing in...</> : <><i className="fa fa-sign-in-alt me-2"></i> Sign In</>}
          </button>
        </form>
      </div>
    </div>
  );
}
